import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const showAccountNameRequest = (id, { dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', `/account_names/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const indexAccountNameRequest = ({ dispatch, format, params = {}, failureCallback, successCallback }) => {
  let formatt = '';
  if (format) {
    formatt = `.${format}`;
  }
  ApiService.request('get', `/account_names${formatt}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });
};

export const validateAccountNameRequest = ({ dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('post', '/account_names/validate', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });

export const updateAccountNameRequest = (id, { dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('put', `/account_names/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });

export const createAccountNameRequest = ({ dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('post', '/account_names', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });

export const deleteAccountNameRequest = (id, { dispatch, failureCallback, successCallback }) =>
  ApiService.request('delete', `/account_names/${id}`, {
    dispatch,
    failureCallback,
    successCallback
  });

export const debounceIndexAcountNameRequest = AwesomeDebouncePromise(indexAccountNameRequest, 300);
